import { LOCAL_STORAGE_ITEMS } from "../utils/constants";

export const REQUEST_STATE = () => {
  return GetKitcheServiceAddress() + "/api/v1/order/customerDisplay";
};

export const GET_LANGUAGE_URL = () => {
  return GetKitcheServiceAddress() + "/api/v1/configuration/systemInfo";
};

export const HUBS_URL = () => {
  return GetKitcheServiceAddress() + "/signalr";
};

const GetKitcheServiceAddress = () =>
  localStorage.getItem(LOCAL_STORAGE_ITEMS.KITCHEN_SERVICE_URL);



// WEBPACK FOOTER //
// ./src/api/routes.js